module.exports = __webpack_public_path__ + "static/9-08ad486e01aa01ac5cf5ec2c8e438edb.png";